const teaserStyle = Object.freeze({
  podcastIconColor: isHighlight => 'primary',
});

export default teaserStyle;
